import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { ViewerNavbar } from '../components/UI/ViewerNavbar';
import { DirectionalOutlet } from '../components/UI/DirectionalOutlet';
import { FullPageSpinner } from '../components/UI/Spinner';
import appStyles from '../App.module.css';

export const ViewerLayout: React.FC = () => {
  const { user, initialized } = useAuthStore();

  if (!initialized) return <FullPageSpinner />;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className={appStyles['shell']}>
      <ViewerNavbar />
      <main>
        <DirectionalOutlet />
      </main>
    </div>
  );
};
